import Vue from 'vue'
import { EnvUtil } from 'kuaidong-lib'
import Vuex, { createLogger } from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {},
  strict: EnvUtil.isDev(),
  plugins: EnvUtil.isDev() ? [createLogger()] : [],
  actions: {
    reset() {
      for (const key in this.state as any) {
        this.commit(`${key}/reset`)
      }
    },
  },
})
